
import { Component, Mixins, Prop } from "vue-property-decorator";
import { VuetifyMixin, BAIconsMixin } from "../../mixins";


@Component
export default class HintText extends Mixins(VuetifyMixin, BAIconsMixin) {
	}
